import { Component, Input } from '@angular/core';
import { VersionHistoryChangesPanelComponent } from '@components/version-history-changes-panel/version-history-changes-panel.component';
import { ChangesObject } from 'icreate/common/models/versions-history';

@Component({
    selector: 'app-mimics-changes-panel',
    templateUrl: './mimics-changes-panel.component.html',
    styleUrls: ['../version-history-changes-panel/version-history-changes-panel.component.css'],
    standalone: false,
})
export class MimicsChangesPanelComponent extends VersionHistoryChangesPanelComponent {
    @Input() changes: ChangesObject;
}
